import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    dataSearchInputBlock: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: '100%',
      [theme.breakpoints.down('lg')]: {
        height: '1385px',
        alignItems: 'start'
      }
    },
    dataentryKeyboardBox: {
      '& > * ': {
        [theme.breakpoints.only('lg')]: {
          height: '445px'
        }
      }
    },
    dataSearchIcontBlock: {
      display: 'flex',
      flexDirection: 'row',
      flex: '0 1 auto',
      justifyContent: 'flex-end',
      background: 'transparent',
      padding: '8px 0px 0px 0px',
      margin: '0px 0px 48px 0px',
      [theme.breakpoints.only('lg')]: {
        margin: '0px 0px 0px 0px'
      }
    },
    dataentryTitleBox: {
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 24px 0px',
      [theme.breakpoints.only('lg')]: {
        margin: '0px 0px 0px 0px'
      }
    }
  })
);
